module.exports = __webpack_public_path__ + "static/media/nynäshamn-bostäder.9126cfd1.png";